// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1zxBl","inner":"Footer_inner__2xZx6","nextIcon":"Footer_nextIcon__1GPge","innerLeft":"Footer_innerLeft__12OWn"};